import { render, staticRenderFns } from "./LicitacaoAtualizacao.vue?vue&type=template&id=25810eb4"
import script from "./LicitacaoAtualizacao.vue?vue&type=script&lang=js"
export * from "./LicitacaoAtualizacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports